let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i2MEP")).then(() => parcelRequire('17tab'));